module.exports = __webpack_public_path__ + "assets/images/project/map-logo-svg/mobile1.png?v=5306a18f";